import React, { createContext, FC, ReactNode, useCallback, useContext, useMemo } from 'react';
import _get from 'lodash/get';

const FieldPrefixContext = createContext<{ prefix: string | null }>({
  prefix: null
});

interface FieldPrefixProviderProps {
  children: ReactNode;
  prefix: string;
}

export const FieldPrefixProvider: FC<FieldPrefixProviderProps> = ({ children, prefix }) => {
  const contextValue = useMemo(() => ({ prefix }), [prefix]);

  return <FieldPrefixContext.Provider value={contextValue}>{children}</FieldPrefixContext.Provider>;
};

export const useFieldPrefix = () => {
  const context = useContext(FieldPrefixContext);

  const getPrefixedFieldName = useCallback(
    (name?: string) => [context.prefix, name].filter(Boolean).join('.'),
    [context?.prefix]
  );

  const getPrefixedFieldValue = useCallback(
    (value?: object, name?: string) => {
      const prefixedName = getPrefixedFieldName(name);

      return prefixedName ? _get(value, prefixedName) : value;
    },
    [getPrefixedFieldName]
  );

  return {
    prefix: context.prefix,
    getPrefixedFieldName,
    getPrefixedFieldValue
  };
};
